import React from "react";
import ReactPaginate from "react-paginate";

const Pagination = ({ onPageChange, totalPages, activePage }) => {
  const handlePageClick = (event) => {
    onPageChange(event.selected + 1);
  };
  return (
    <div className="d-flex justify-content-end">
      <ReactPaginate
        previousLabel={
          <i
            className="icon-prev-arrow"
            style={{ color: "#979797", fontWeight: "bold" }}
          ></i>
        }
        previousClassName="previous-page"
        previousLinkClassName="previous-link"
        nextLabel={
          <i
            className="icon-next-arrow"
            style={{ color: "#979797", fontWeight: "bold" }}
          ></i>
        }
        nextClassName="previous-page"
        nextLinkClassName="previous-link"
        forcePage={activePage - 1}
        breakLabel="..."
        breakClassName="break"
        disabledClassName="next-prev"
        breakLinkClassName="break-link"
        pageCount={totalPages}
        marginPagesDisplayed={3}
        onPageChange={handlePageClick}
        containerClassName="pagination"
        pageClassName="inactive-page"
        pageLinkClassName="inactive-link"
        activeLinkClassName="active-link"
        activeClassName="active-page"
      />
    </div>
  );
};

export default Pagination;
